(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-card').forEach(card => {
      const tags = (card.dataset.productTags || '').toLowerCase();
      const title = card.dataset.productTitle || 'Produktas';

      const atcButtons = card.querySelectorAll(
        '.quick-add__button, button[name="add"], .product-form__submit'
      );

      // If product is inquiry-only:
      if (tags.includes('inquiry-only')) {

        // 1. Hide ATC / quick add INSIDE THIS CARD ONLY (not remove whole forms)
        atcButtons.forEach(btn => {
          btn.style.display = 'none';
        });

        const quickAddBlocks = card.querySelectorAll('.quick-add, .shopify-payment-button, .product-card__actions');
        quickAddBlocks.forEach(block => {
          block.style.display = 'none';
        });

        // 2. Inject inquiry button if not already there
        if (!card.querySelector('.product-card__inquiry-cta')) {
          const inquiryBtn = document.createElement('a');
          inquiryBtn.className = 'product-card__inquiry-cta';
          inquiryBtn.href = '/pages/contact?subject=' + encodeURIComponent(title);
          inquiryBtn.textContent = 'Teirautis dėl užsakymo';

          const content = card.querySelector('.product-card__content');
          if (content) {
            content.appendChild(inquiryBtn);
          }
        }

        // 3. Mark card for CSS
        card.classList.add('product-card--inquiry');
      } else {
        // Normal product = style ATC yellow
        card.classList.add('product-card--normal-atc');
        atcButtons.forEach(btn => {
          btn.classList.add('product-card__atc-cta');
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
